const safeError = (error: unknown): string => {
  if (error instanceof Error) return `${error.name}: ${error.message}`;
  return typeof error === 'string' ? error : 'Unknown error';
};

export const logger = {
  error(context: string, error?: unknown) {
    if (
      (globalThis as unknown as Record<string, unknown>)
        .__FOUND_IT_INVITATION_SANITIZING__
    )
      return;
    if (process.env.NODE_ENV !== 'production')
      console.error(context, safeError(error));
  },
  warn(context: string, error?: unknown) {
    if (
      (globalThis as unknown as Record<string, unknown>)
        .__FOUND_IT_INVITATION_SANITIZING__
    )
      return;
    if (process.env.NODE_ENV !== 'production')
      console.warn(context, safeError(error));
  },
};
